export default __webpack_public_path__ + "static/media/ScissorIcon.5f0546ad.svg";